import React from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
  List,
  ListItem,
  ListItemText,
  Divider,
} from '@mui/material';

const EditorialBoard: React.FC = () => {
  const editorialBoard = [
    {
      title: 'ГЛАВНЫЙ РЕДАКТОР',
      members: [
        'Земенкова Мария Юрьевна – главный редактор, доктор технических наук, доцент, профессор кафедры транспорта углеводородных ресурсов Института транспорта ФГБОУ ВО «Тюменский индустриальный университет», член диссертационного совета, член НТС ФГБОУ ВО «Тюменский индустриальный университет», г. Тюмень.'
      ]
    },
    {
      title: 'РЕДАКЦИОННАЯ КОЛЛЕГИЯ',
      members: [
        'Агафонов Евгений Дмитриевич – доктор технических наук, доцент, профессор кафедры топливообеспечения и горюче-смазочных материалов ФГАОУ ВО «Сибирский федеральный университет», г. Красноярск.',
        'Агиней Руслан Викторович – доктор технических наук, профессор, ректор ФГБОУ ВО «Ухтинский государственный технический университет», Республика Коми, г. Ухта.',
        'Гладенко Алексей Анатольевич – доктор технических наук, профессор, профессор кафедры нефтегазового дела, стандартизации и метрологии ФГАОУ ВО «Омский государственный технический университет», г. Омск.',
        'Гульков Александр Нефедович – доктор технических наук, профессор, профессор департамента нефтегазовых технологий и нефтехимии ФГБОУ ВО «Дальневосточный федеральный университет», Заслуженный работник высшей школы России, Приморский край, о. Русский.',
        'Данилов Олег Федорович – доктор технических наук, профессор, заведующий кафедрой автомобильного транспорта, строительных и дорожных машин Строительного института ФГБОУ ВО «Тюменский индустриальный университет», г. Тюмень.',
        'Земенков Юрий Дмитриевич – доктор технических наук, профессор, академик Российской академии естественных наук, заведующий кафедрой транспорта углеводородных ресурсов ФГБОУ ВО «Тюменский индустриальный университет», г. Тюмень.',
        'Иванов Вадим Андреевич – доктор технических наук, профессор, профессор кафедры транспорта углеводородных ресурсов ФГБОУ ВО «Тюменский индустриальный университет», г. Тюмень.',
        'Калач Андрей Владимирович – доктор химических наук, профессор, профессор кафедры жилищно-коммунального хозяйства ФГБОУ ВО «Воронежский государственный технический университет».',
        'Кантемиров Игорь Финсурович – доктор технических наук, доцент, заведующий кафедрой проектирования и строительства объектов нефтяной и газовой промышленности ФГБОУ ВО «Уфимский государственный нефтяной технический университет», Республика Башкортостан, г. Уфа.',
        'Коробков Геннадий Евгеньевич – доктор технических наук, профессор, профессор кафедры транспорта и хранения нефти и газа ФГБОУ ВО «Уфимский государственный нефтяной технический университет», Республика Башкортостан, г. Уфа.',
        'Крюков Валерий Анатольевич – доктор экономических наук, профессор, академик Российской академии наук, директор ФГБУН «Институт экономики и организации промышленного производства Сибирского отделения Российской академии наук», г. Новосибирск.',
        'Моор Светлана Михайловна – доктор социологических наук, профессор, профессор кафедры транспорта углеводородных ресурсов ФГБОУ ВО «Тюменский индустриальный университет», г. Тюмень.',
        'Николаев Александр Константинович – доктор технических наук, профессор, профессор кафедры транспорта и хранения нефти и газа ФГБОУ ВО «Санкт-Петербургский горный университет», г. Санкт-Петербург.',
        'Овсянников Виктор Евгеньевич – доктор технических наук, доцент, профессор кафедры технология машиностроения института промышленных технологий и инжиниринга ФГБОУ ВО «Тюменский индустриальный университет», Заслуженный деятель науки РАЕ, г. Тюмень.',
        'Орлова Вера Вениаминовна – доктор социологических наук, доцент, профессор, заведующий кафедрой философии и социологии ФГБОУ ВО «Томский государственный университет систем управления и радиоэлектроники», г. Томск.',
        'Подорожников Сергей Юрьевич – кандидат технических наук, доцент, доцент кафедры транспорта углеводородных ресурсов ФГБОУ ВО «Тюменский индустриальный университет», г. Тюмень',
        'Силин Анатолий Николаевич – доктор социологических наук, профессор, профессор кафедры маркетинга и муниципального управления ФГБОУ ВО «Тюменский индустриальный университет», Заслуженный деятель науки Российский Федерации, г. Тюмень.',
        'Старцев Андрей Васильевич – доктор технических наук, профессор, профессор института агроинженерии ФГБОУ ВО «Южно-Уральский государственный аграрный университет», г. Челябинск.',
        'Фетисов Вадим Георгиевич – кандидат технических наук, доцент кафедры инженерной инфраструктуры объектов капитального строительства, Института морских технологий, энергетики и строительства, ФГБОУ ВО «Калининградский государственный технический университет», г. Калининград.',
        'Халин Анатолий Николаевич – кандидат технических наук, доцент, директор института промышленных технологий и инжиниринга ФГБОУ ВО «Тюменский индустриальный университет», г. Тюмень.',
        'Чекардовский Михаил Николаевич – доктор технических наук, доцент, профессор кафедры инженерных систем и сооружений строительного института ФГБОУ ВО «Тюменский индустриальный университет», г. Тюмень.',
        'Чижевская Елена Леонидовна – кандидат экономических наук, доцент кафедры транспорта углеводородных ресурсов ФГБОУ ВО «Тюменский индустриальный университет», г. Тюмень.'
      ]
    }
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Редакционная коллегия
      </Typography>
      
      {editorialBoard.map((section, index) => (
        <Paper key={index} sx={{ p: 3, mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 'bold' }}>
            {section.title}
          </Typography>
          <List>
            {section.members.map((member, memberIndex) => (
              <React.Fragment key={memberIndex}>
                <ListItem>
                  <ListItemText
                    primary={member}
                    primaryTypographyProps={{
                      sx: { textAlign: 'justify' }
                    }}
                  />
                </ListItem>
                {memberIndex < section.members.length - 1 && <Divider />}
              </React.Fragment>
            ))}
          </List>
        </Paper>
      ))}
    </Container>
  );
};

export default EditorialBoard; 